import { Typography } from 'antd'

import { StrictOmit } from '../../../../types/utilities'
import { pretty } from '../../../../utils/decimal'
import { FieldDigitProps } from '../../interface'

/**
 * 数字组件
 */
export const FieldDigit = ({
  className,
  style,
  value,
  precision,
  text
}: StrictOmit<FieldDigitProps, 'type'>) => {
  const digitStr = pretty(value, {
    precision
  })

  const valueNode = text ? (
    <Typography.Text {...text}>{digitStr}</Typography.Text>
  ) : (
    digitStr
  )

  return (
    <span className={className} style={style}>
      {valueNode}
    </span>
  )
}
